import 'lib/adaptivefontsize';
import { openPopup } from "../../../core/widgets/popup";
import { ReviewList } from "modules/reviews/common/model/reviewlist";
import { ReviewListMobile } from "modules/reviews/common/model/reviewlistmobile";
import 'modules/reviews/common/components';
import { SaleList } from "modules/shops/page/model/salelist"
import { siteUrl } from "../../../core/utils/url";

export function init(options) {
    const o = {
        shopId: null,
        reviews: [],
        reviewsCount: 0,
        reviewsAverageRating: 0,
        sales: [],
        salesCount: 0,
        sizeTableData: null,

        ...options
    };

    const viewModel = new ViewModel(o.shopId, o.sizeTableData);

    initCustomSelect();
    descriptionToggler();
    infoDrop();

    viewModel.initReviews(o.reviews, o.reviewsCount, o.reviewsAverageRating);
    viewModel.initSales(o.sales, o.salesCount);

    ko.applyBindings(viewModel, $('#pageWrapper')[0]);

    viewModel.postInit();

    fetchFacebookPixelCustomEvents(o.shopId);
}

function initCustomSelect() {
    $('.reviews-panel').find('select[rel=chosen]').chosen();
}

function descriptionToggler() {
    const $container = $('.description-text');
    const $text = $container.find('.description-inner');
    if($container.height() < $text.height()){
        $text.find('.more-btn').show();
        $text.find('.more-btn').click(function(){
            const text = $text.find('.description-full').text();
            const template = require('./templates/description-popup.html');
            const content = $.tmpl(template, {text});
            openPopup(content, {
                cssClass: 'description-popup'
            });
        })
    }
}

function infoDrop() {
    const $container = $('.shop-dropdown');
    const $toggler = $container.find('.dropdown-header');
    const $content = $container.find('.dropdown-content');
    const $inner = $content.find('.content-inner');
    const $text = $container.find('.text');
    const $text_inner = $text.find('.text-inner');
    const text_const_height = $text.css('height');
    $toggler.click(function(){
        if($(this).hasClass('opened')){
            $(this).siblings($content).css('height', 0);
            $(this).closest($container).find($text).css('height', text_const_height).removeClass('opened');
            $(this).removeClass('opened');
        }
        else{
            let height = $(this).siblings($content).find($inner).innerHeight();
            let text_height = $(this).closest($container).find($text_inner).innerHeight();
            $(this).siblings($content).css('height', height);
            $(this).closest($container).find($text).css('height', text_height).addClass('opened');
            $(this).addClass('opened');
        }
    });
}

function sizeTableToggler() {
    const $container = $('.size-table-popup');
    const $tab = $container.find('.size-tabs-wrapper .size-tab');
    $tab.click(function(){
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
        let rel = $(this).attr('rel');
        const $content = $container.find('.img-wrapper[rel='+rel+']');
        $content.show();
        $content.siblings().hide();
    })
}

class ViewModel {
    shopId = null;
    /** @type {ReviewList} */
    reviewList = null;
    /** @type {ReviewListMobile} */
    reviewListMobile = null;
    reviewListOrder = ko.observable();
    saleList = null;
    _sizeTableData = null;
    _$breadcrumbsSearch = $('#breadcrumbsSearch').find('.search-input');

    constructor(shopId, sizeTableData) {
        this.shopId = shopId;
        this.reviewList = new ReviewList({
            infScrollWrapper: $('.review-columns'),
            columns: true,
            columnsCount: 4,
            calculateAverageRating: true
        });
        this.reviewListMobile = new ReviewListMobile({
            infScrollWrapper: $('.review-rows')
        });
        this._sizeTableData = sizeTableData;

        if(window.history !== undefined) {
            window.history.replaceState(this._getState(), '');
            $(window).on('popstate', this._popState.bind(this));
        }
    }

    initReviews(reviews, totalCount, averageRating) {
        let orderSelectInitialized = false;

        // Fill review lists with preloaded data
        this._setReviews(this.reviewList, reviews, totalCount, averageRating);
        this._setReviews(this.reviewListMobile, reviews, totalCount);

        this.reviewListOrder.subscribe(() => {
            if(orderSelectInitialized) {
                this._reloadReviews(this.reviewList);
            } else {
                orderSelectInitialized = true;
            }
        });

        $('#breadcrumbsSearch').submit((e) => {
            e.preventDefault();

            if(window.history !== undefined) {
                const state = this._getState();
                const pathParts = location.pathname.split('/'); //If pathname starts from '/' the first element is empty
                const path = pathParts.slice(0, pathParts[0] ? 2 : 3).join('/');
                window.history.pushState(state, '', `${path}/` + encodeURIComponent(state.search));
            }

            this._reloadReviews(this.reviewList);
            this._reloadReviews(this.reviewListMobile);
            this._updateMeta();
        });
        this.reviewList.enableSizWatcher();
    }

    initSales(sales, total) {
        this.saleList = new SaleList(sales, total, this.shopId, '.sales-wrapper', '.mobile-sales-wrapper');
    }

    postInit() {
        this.saleList.postInit();
    }

    openSizeTable() {
        if(this._sizeTableData !== null) {
            if(Array.isArray(this._sizeTableData)) {
                const template = require('./templates/size-table.html');
                const content = $.tmpl(template, {tables: this._sizeTableData});
                openPopup(content, {
                    cssClass: 'size-table-popup',
                    onOpen: sizeTableToggler
                });
            } else {
                window.open(this._sizeTableData);
            }
        }
    }

    toggleShopTab(item, event) {
        const $tab = $(event.currentTarget);
        let id = $tab.attr('href');
        $(id).show();
        $(id).siblings().hide();
        $tab.addClass('active');
        $tab.siblings($tab).removeClass('active');
        if(id == '#sales-wrapper') {
            this.saleList.refreshMobile();
        }
    }

    _getReviewsRequestParams() {
        const params = {
            shop_id : this.shopId,
            sort_by: this.reviewListOrder()
        };

        let search;
        if(search = this._$breadcrumbsSearch.val()) {
            params.search = search;
        }

        return params;
    }

    /**
     *
     * @param {ReviewList} list
     * @param {number} reviews
     * @param {number} totalCount
     * @param {number|null} averageRating
     */
    _setReviews(list, reviews, totalCount, averageRating = null) {
        list.loadFromArray(reviews, totalCount, this._getReviewsRequestParams());

        if(averageRating !== null) {
            $('#reviewCount').text(totalCount);
            $('#ratingValue').text(averageRating);
        }
    }

    /** @param {ReviewList} list */
    _reloadReviews(list) {
        list.load(this._getReviewsRequestParams())
            .done(() => {
                if(list.averageRating !== null) {
                    $('#reviewCount').text(list.totalCount);
                    $('#ratingValue').text(list.averageRating);
                }
            });
    }

    _getState() {
        return {
            search: this._$breadcrumbsSearch.val()
        }
    }

    _setState(state) {
        this._$breadcrumbsSearch.val(state.search);
        this._updateMeta();
    }

    _popState(e) {
        if(e.originalEvent.state !== null) {
            const stateHasChanged = !!ViewModel.compareState(this._getState(), e.originalEvent.state);
            if(stateHasChanged) {
                this._setState(e.originalEvent.state);
                this._reloadReviews(this.reviewList);
                this._reloadReviews(this.reviewListMobile);
            }
        }
    }

    _updateMeta() {
        $.get(
            'shops/getShopPageMeta',
            {shop_id: this.shopId, search: this._$breadcrumbsSearch.val()},
            (response) => {
                if(response.success) {
                    document.title = response.title;
                    $("meta[name='description']").attr('content', response.description);
                }
            },
            'json'
        );
    }

    static compareState(a, b) {
        return a.search === b.search ? 0 : 1;
    }
}

function fetchFacebookPixelCustomEvents(shopId) {
    $.post(
        siteUrl('shops/getShopPageFacebookPixelCustomEvents'),
        {
            shop_id: shopId,
            referrer: document.referrer
        },
        null,
        'json'
    )
        .done(response => {
            if (response.success) {
                response.events.forEach(event => zde.modules.core.facebook_pixel_custom_events.emit(event));
            }
        });
}


// WEBPACK FOOTER //
// ./modules/shops/page/index.js